import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';

// Import JS Modules
import albums from './albums';
import Store from '../../_utils/tools/store';
import {
  builderDispatch,
  WebUI
} from '../../_utils/ui';
import Spinner from '../../_utils/spinner';
import {
  pluralizer,
  localDateFormat
} from '../utils/utils';

import UrlBuilder from '../../_utils/url-building';
// Import JSX Modules
import ServiceHeader from './service-header';
import FileSelectorMixin from '../loader-mixins/file-selector-mixin';
import UrlLoaderUploadMixin from '../loader-mixins/url-loader-upload-mixin';
import FileClearingMixin from '../loader-mixins/file-clearing-mixin';
import Thumbnails from '../thumbnails/thumbnails';
import UrlThumbnail from '../thumbnails/url-thumbnail';
import NotLoggedIn from './not-logged-in';
import SelectAllSection from './select-all-section';
import StreamPhotos from './stream-photos';
import MyAlbumsAndTimelines from './my-albums-and-timelines';
import NoPhotosMessage from './no-photos-messgae';
import MoreButton from '../utils/more-button';
import PhotoStorageMessage from './photo-storage-message';
import sendToGoogleAnalytics from "../../_prism-builder/desktop/slot-tools/send-to-google-analytics";

const DEFAULT_COVER_HEIGHT = 136;
const DEFAULT_SELECT_ALL_HEIGHT = 33;

const MyPhotosImport = createReactClass({
  mixins: [UrlLoaderUploadMixin, FileSelectorMixin, FileClearingMixin],

  displayName: 'My Photos Import',

  getInitialState() {
    const { App } = window;

    return {
      selectedAlbum: null,
      view: 'stream', //stream, timelines, allAlbums, albumContent
      total: null,
      stream: [],
      streamPage: 1,
      timelines: [],
      timelinesPage: 1,
      loggedIn: App && App.order.logged_in(),
      showAlert: true
    };
  },

  componentDidMount() {
    this.files = (this.files || []);
    this.streamPerPage = this.props.isMobile ? 15 : 16;
    this.timelinesPerPage = this.props.isMobile ? 15 : 32;

    this.builderDispatchToken = builderDispatch.register(payload => {
      if (payload.type === WebUI.LOGIN) {
        this.setState({
          loggedIn: true
        }, () => {
          this.loadAlbums();
          this.fetchData('stream', this.state.streamPage, this.streamPerPage);
          this.fetchData('timelines', this.state.timelinesPage, this.timelinesPerPage);
        });
      }
    });

    this.albumsContents = {};

    if (this.state.loggedIn) {
      this.loadAlbums();
      this.fetchData('stream', this.state.streamPage, this.streamPerPage);
      this.fetchData('timelines', this.state.timelinesPage, this.timelinesPerPage);
    }
  },

  componentWillUnmount() {
    builderDispatch.unregister(this.builderDispatchToken);
  },

  render() {
    const $body = (() => {
      if (this.state.loggedIn) {
        if (this.state.view == 'stream') {
          return this.renderStream();
        }

        if (this.state.view == 'timelines') {
          return this.renderTimelines();
        }

        if (this.state.selectedAlbum && this.state.view == 'albumContent') {
          return this.renderAlbumContent();
        }

        if (this.state.view == 'allAlbums') {
          return this.renderAlbumList();
        }
      }

      return (
        <NotLoggedIn
          storeName={Store.name}
          showAlert={this.state.showAlert}
          handleCloseAlert={this.handleCloseAlert}
          toggleShowAlert={this.handleToggleShowAlert}
        />
      );
    })();
    return (
      <div
        id={'image-loader-service-' + this.props.service}
        style={{ height: this.props.height }}
        className={classNames('image-loader-service',
          this.props.service,
          this.state.loggedIn ? this.state.view : 'guest',
          { 'd-none': !this.props.isActive })}>
        {$body}
      </div>
    );
  },

  renderStream() {
    const { total, stream } = this.state,
      coversHeight = $('.stream-body > .covers').outerHeight() || DEFAULT_COVER_HEIGHT,
      selectAllHeight = $('.stream-body > .select-all').outerHeight() || DEFAULT_SELECT_ALL_HEIGHT,
      componentHeight = (this.props.height - coversHeight - selectAllHeight);

    if (!this.state.streamLoaded) {
      return <Spinner className="h-100" />;
    }

    if (stream.length === 0) {
      return <NoPhotosMessage />;
    }

    return (
      <div className="stream-body">
        <MyAlbumsAndTimelines
          myAlbumsCover={this.getCover("stream")}
          timelinesCover={this.getCover("timelines")}
          onMyAlbumsClick={() => this.handleChangeView("allAlbums")}
          onTimelinesClick={() => this.handleChangeView("timelines")}
        />
        <SelectAllSection
          enabled
          label="Select all photos"
          title="All Photos"
          selectedAll={this.handleAllSelected(stream)}
          selectAll={() => this.handleSelectAll(stream)}
          selectNone={() => this.handleSelectNone(stream)}
        />
        <StreamPhotos
          hasMoreButton={total > stream.length}
          height={componentHeight}
          isSelected={this.isSelected}
          photos={stream}
          total={total || 0}
          onMoreButtonClick={() => this.handleLoadMoreButtonClick('stream')}
          onSelect={this.handleSelect}
          onUnSelect={this.handleUnSelect}
        />
        {
          !!window.document.referrer &&
          <PhotoStorageMessage
            isOpen={this.state.showAlert}
            storeName={Store.name + '.com'}
            variant="all-photos-alert"
            onClose={this.handleCloseAlert}
          />
        }
      </div>
    );
  },

  renderAlbumList() {
    if (!this.state.albumsLoaded) return <Spinner className="h-100" />;

    const thumbnails = albums.data.map(album => {
      return {
        source: 'album',
        album: album
      };
    }).sort((a, b) => b.album.id - a.album.id);

    return (
      <div key="albums-list" className="albums-list-body">
        <ServiceHeader
          title="My Albums"
          onBackClick={() => this.handleChangeView("stream", false)}
        />
        {
          thumbnails.length ?
            <Thumbnails
              files={thumbnails}
              isSelected={this.isSelected}
              itemIdentifier="name"
              handleSelect={this.handleAlbumSelected}
              displayCaption={true}
              withOrientation
            />
            :
            <NoPhotosMessage />
        }
      </div>
    );
  },

  renderAlbumContent() {
    const { selectedAlbum } = this.state;
    const albumContent = this.albumsContents[selectedAlbum.id];

    if (!albumContent) {
      return (
        <div
          className="album-content-body h-100"
          key="albumContent"
        >
          <ServiceHeader
            title={selectedAlbum.title}
            onBackClick={() => this.handleChangeView("allAlbums")}
          />
          <Spinner className="h-100" />
        </div>
      );
    }

    if (albumContent.photos.length) {
      return (
        <div key="albumContent" className="album-content-body" >
          <ServiceHeader
            title={selectedAlbum.title}
            onBackClick={() => this.handleChangeView("allAlbums")}
          />
          {this.state.selectedAlbum &&
            <SelectAllSection
              enabled
              label="Select all photos"
              title={pluralizer(albumContent.photos.length, 'photo')}
              selectedAll={this.handleAllSelected(albumContent.photos)}
              selectAll={() => this.handleSelectAll(albumContent.photos)}
              selectNone={() => this.handleSelectNone(albumContent.photos)}
            />
          }

          <Thumbnails
            files={albumContent.photos}
            isSelected={this.isSelected}
            itemIdentifier="url"
            handleSelect={this.handleSelect}
            handleUnSelect={this.handleUnSelect}
            withOrientation
          />
        </div>
      );
    }
  },

  renderTimelines() {
    const { timelines, total } = this.state;

    const timelinesByDate = timelines.reduce((memo, photo) => {
      const photoDateTaken = localDateFormat(photo.date_taken);
      memo[photoDateTaken] = memo[photoDateTaken] || [];
      memo[photoDateTaken].push(photo);
      return memo;
    }, {});

    return (
      <div className="timelines-body">
        <ServiceHeader
          title="Timelines"
          onBackClick={() => this.handleChangeView("stream", false)}
        />
        <div id="timelinesDiv"
          style={{
            height: this.props.height,
            overflow: "auto"
          }}
        >
          <div className="scroll-box">
            {
              Object.keys(timelinesByDate).map((date, i) => (
                <div key={`timelines-${i}`} className="timeline w-100">
                  <SelectAllSection
                    enabled
                    key={date}
                    label={`${date} Select all photos`}
                    title={date}
                    selectedAll={this.handleAllSelected(timelinesByDate[date])}
                    selectAll={() => this.handleSelectAll(timelinesByDate[date])}
                    selectNone={() => this.handleSelectNone(timelinesByDate[date])}
                  />
                  <div className='thumbnails'>
                    {
                      timelinesByDate[date].map(photo => (
                        <UrlThumbnail
                          file={photo}
                          key={`stream-${photo.id}`}
                          selected={this.isSelected(photo)}
                          onSelect={this.handleSelect}
                          onUnSelect={this.handleUnSelect}
                          withOrientation
                        />
                      ))
                    }
                  </div>
                </div>
              ))
            }
            {
              total > timelines.length &&
              <MoreButton
                id="load-more-timelines"
                onMoreButtonClick={() => this.handleLoadMoreButtonClick('timelines')}
              />
            }
          </div>
        </div>
      </div>
    );
  },

  loadAlbums() {
    if (this.state.loggedIn) {
      albums.load(() => {
        this.setState({
          albumsLoaded: true
        });
      });
    }
  },

  getDestUrl(dest, page, perPage) {
    const params = {
      page,
      per_page: perPage,
      timelines: dest === 'timelines' ? true : undefined
    };

    return '/account/my-photos/stream.json?' + UrlBuilder.buildURLQuery(params);
  },

  fetchData(dest, page, perPage) {
    fetch(this.getDestUrl(dest, page, perPage), {
      credentials: 'same-origin'
    })
      .then(response => response.json())
      .then(data => {
        data.photos.forEach(photo => {
          photo.source = 'url'
        });

        const destPage = `${dest}Page`;

        this.setState({
          [dest]: this.state[dest].concat(data.photos),
          [destPage]: ++this.state[destPage],
          total: data.total,
          [dest + 'Loaded']: true
        }, () => this.scrollIntoView(dest));
      })
      .catch(error => {
        console.error('Error:', error);
        this.setState({ [dest + 'Loaded']: true })
      });
  },

  handleChangeView(view, hideMenu = true) {
    this.props.onHideMenu(hideMenu);
    this.setState({ view: view, selectedAlbum: null });
  },

  getCover(view) {
    if (this.state[view].length) {
      return this.state[view][0].url;
    }
  },

  handleSelect(photo) {
    if (this.files.some(file => file.id === photo.id)) {
      // this photo is already selected
      return;
    }

    this.files.push({ ...photo }); // photo object is cloned so modificatons made to it don't persist

    this.props.onFilesSelected();
  },

  handleUnSelect(photo) {
    this.files = this.files.filter(f => f.id !== photo.id);
    this.props.onFilesSelected();
  },

  handleSelectAll(photos) {
    const existingFileIds = this.files.reduce((acc, file) => {
      acc[file.id] = true;
      return acc;
    }, {});

    const photosToAdd = photos.filter((p) => p.viable && !existingFileIds[p.id]).map((p) => ({ ...p })); // photo object is cloned so modificatons made to it don't persist
    this.files = this.files.concat(photosToAdd);

    this.props.onFilesSelected();
  },

  handleSelectNone(photos) {
    this.files = this.files.filter(f => !photos.find(p => f.id === p.id));

    this.props.onFilesSelected();
  },

  isSelected(photo) {
    const ids = this.files.map(file => file.id);
    return ids.includes(photo.id);
  },

  triggerFeatureTracking() {
    sendToGoogleAnalytics('my-photos','import')
  },

  handleAllSelected(photos) {
    if (!photos.length) return false;

    this.triggerFeatureTracking()

    const fileIds = this.files.reduce((memo, f) => {
      memo[f.id] = true;
      return memo;
    }, {});

    return photos.every(p => fileIds[p.id]);
  },

  handleViewAllAlbums(e) {
    e.preventDefault();

    this.setState({
      selectedAlbum: null
    });

    if (typeof this.props.onHideMenu === 'function') {
      this.props.onHideMenu();
    }

    if (typeof this.props.toggleAlbumSelected === 'function') {
      this.props.toggleAlbumSelected();
    }
  },

  handleAlbumSelected(album) {
    this.setState({
      selectedAlbum: album,
      view: 'albumContent'
    });

    if (typeof this.props.onHideMenu === 'function') {
      this.props.onHideMenu(true);
    }

    if (typeof this.props.toggleAlbumSelected == 'function') {
      this.props.toggleAlbumSelected();
    }

    if (this.albumsContents[album.id]) {
      return;
    }

    const that = this;

    fetch(album.link, {
      credentials: 'same-origin'
    }).
      then(response => response.json()).
      then(data => onAlbumLoaded(data));

    function onAlbumLoaded(data) {
      data.photos.forEach(photo => {
        photo.source = 'url';
      });

      if (that.albumsContents[album.id]) {
        that.albumsContents[album.id].photos = that.albumsContents[album.id].photos.concat(data.photos);
      } else {
        that.albumsContents[album.id] = data;
      }

      that.forceUpdate();
    }
  },

  handleToggleShowAlert(e) {
    e.preventDefault();
    const prevShowAlertState = this.state.showAlert;
    this.setState({ showAlert: !prevShowAlertState });
  },

  handleCloseAlert() {
    this.setState({ showAlert: false });
  },

  _clear() {
    this.setState({
      selectedAlbum: null,
      view: 'stream'
    });
  },

  handleLoadMoreButtonClick(source) {
    $(`#${source}Div .image-container`).addClass('seen');
    this.fetchData(source, this.state[`${source}Page`], this[`${source}PerPage`]);
  },

  scrollIntoView(source) {
    const element = $(`#${source}Div .image-container:not(.seen)`)[0];
    element && element.scrollIntoView({ behavior: "smooth", block: "start", inline: "end" });
  },
});

export default MyPhotosImport;
